import { CHANGE_PROP as r } from "./types.js";
const o = {
  histFileActionComplete: !1
};
function n(e = o, t) {
  switch (t.type) {
    case r:
      return {
        ...e,
        ...t.payload
      };
    default:
      return e;
  }
}
export {
  n as propChangeReducer
};
//# sourceMappingURL=reducers.js.map
